<template lang="html">
  <div class="policy">
    <div v-if="isEmpty(industries)" class="policy__item buyerIndustry">
      <div class="item__title">
        <span>投資/出資の対象業種</span>
      </div>
      <div class="item__content buyerIndustry__list">
        <label
          v-for="(industry, index) in industries"
          :key="index"
          class="buyerIndustry__item"
        >
          {{ industry }}
        </label>
      </div>
    </div>
    <div v-if="isEmpty(investments)" class="policy__item buyerIndustry">
      <div class="item__title">
        <span>投資/出資の形態</span>
      </div>
      <div class="item__content buyerIvestment__list">
        <label
          v-for="(investment, index) in investments"
          :key="index"
          class="buyerInvestment__item"
        >
          {{ investment }}
        </label>
      </div>
    </div>
    <div v-if="isEmpty(prices)" class="policy__item buyerPrice">
      <div class="item__title">
        <span>投資/出資する金額</span>
      </div>
      <div class="item__content buyerPrice__list">
        <label
          v-for="(price, index) in prices"
          :key="index"
          class="buyerPrice__item"
        >
          {{ price }}
        </label>
      </div>
    </div>
    <div v-if="isEmpty(ma_policy.target_area)" class="policy__item buyerField">
      <div class="item__title">
        <span>投資/出資の対象領域</span>
      </div>
      <div class="item__content">
        {{ ma_policy.target_area }}
      </div>
    </div>
    <div v-if="isEmpty(ma_policy.point)" class="policy__item point">
      <div class="item__title">
        <span>重視するポイント</span>
      </div>
      <div class="item__content">
        {{ ma_policy.point }}
      </div>
    </div>
    <div v-if="isEmpty(ma_policy.point)" class="policy__item buyerExclude">
      <div class="item__title">
        <span>除外対象（投資/出資できない先）</span>
      </div>
      <div class="item__content">
        {{ ma_policy.point }}
      </div>
    </div>
    <div
      v-if="isEmpty(ma_policy.acquisition_flow)"
      class="policy__item acquisitionFlow"
    >
      <div class="item__title">
        <span>買収の流れ</span>
      </div>
      <div class="item__content">
        {{ ma_policy.acquisition_flow }}
      </div>
    </div>
    <div v-if="isEmpty(ma_policy.about_team)" class="policy__item aboutTeam">
      <div class="item__title">
        <span>投資・出資後の方針</span>
      </div>
      <div class="item__content">
        {{ ma_policy.about_team }}
      </div>
    </div>
    <div
      v-if="isEmpty(ma_policy.dispatch_member)"
      class="policy__item dispatchMember"
    >
      <div class="item__title">
        <span>投資/出資の対象地域</span>
      </div>
      <div class="item__content">
        {{ ma_policy.dispatch_member }}
      </div>
    </div>
    <!--    <div v-if="isEmpty(ma_policy.hire_member)" class="policy__item hireMember">-->
    <!--      <div class="item__title">-->
    <!--        <span>役員登⽤</span>-->
    <!--      </div>-->
    <!--      <div class="item__content">-->
    <!--        {{ ma_policy.hire_member }}-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div-->
    <!--      v-if="isEmpty(ma_policy.company_name)"-->
    <!--      class="policy__item companyName"-->
    <!--    >-->
    <!--      <div class="item__title">-->
    <!--        <span>会社名、オフィスの統合</span>-->
    <!--      </div>-->
    <!--      <div class="item__content">-->
    <!--        {{ ma_policy.company_name }}-->
    <!--      </div>-->
    <!--    </div>-->
    <div v-if="isEmpty(ma_policy.other)" class="policy__item other">
      <div class="item__title">
        <span>その他投資/出資について</span>
      </div>
      <div class="item__content">
        {{ ma_policy.other }}
      </div>
    </div>
  </div>
</template>

<script>
import * as config from '@/assets/config/selector.js'
export default {
  name: 'investorPolicy',
  props: {
    investorInfo: {
      type: Object
    }
  },
  computed: {
    ma_policy() {
      return this.investorInfo.ma_policy
    },
    industries() {
      return this.investorInfo.ma_policy.industry.map(item => {
        return config.typeOfIndustries.find(config => item === config.id).name
      })
    },
    investments() {
      return this.investorInfo.ma_policy.investment.map(item => {
        return config.typeOfInvestments.find(config => item === config.id).name
      })
    },
    prices() {
      return this.investorInfo.ma_policy.price.map(item => {
        return config.priceOfBoughts.find(config => item === config.id).name
      })
    }
  },
  methods: {
    isEmpty(item) {
      const type = typeof item
      switch (type) {
        case 'string':
          return !!item.trim().length
        case 'object': {
          if (Array.isArray(item)) return !!item.length
          else return Object.values(item).every(o => this.isEmpty(o))
        }
        default:
          console.error('no support type')
          return item
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// .policy {
//   margin-top: 4rem;
//   @include respondIn(md) {
//     margin-top: 2rem;
//   }
// }
.policy__item {
  display: flex;
  border-bottom: 1px solid #d2d2d2;
  @include respondIn(md) {
    display: block;
    border: none;
  }
}
.item__title {
  width: 33.33%;
  background-color: #f4f4f4;
  padding: 1rem 0rem 1rem 2.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @include respondIn(md) {
    width: 100%;
    justify-content: center;
    padding: 1rem 0;
  }
}
.item__content {
  width: 66.66%;
  padding: 1rem;
  text-align: left;
  @include respondIn(md) {
    width: 100%;
  }
  label {
    display: inline-block;
    background-color: #f4f4f4;
    padding: 0.5rem;
    margin-right: 0.5rem;
    margin-top: 0.5rem;
    @include respondIn(md) {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
